module.exports = __webpack_public_path__ + "static/img/Ben-Elias.b60dc46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ben-Elias.jpg
// module id = F6bs
// module chunks = 0